module.exports = __webpack_public_path__ + "img/tab-history-hover.179ae0cf.svg";